export default __webpack_public_path__ + "806f332ed52cdc1e55e5b3786d8ef8f3.png";